import {ATHLETE_WIDGET} from "../../../athlete-widget-consts";
import {AnalyticsEventHandler} from "../../../../../infrastructure/handlers/analytics-event-handler";
import {AthleteNextGameModuleController} from "../athlete-next-game.module.controller";
import {AthleteNextGameModuleState} from "../models/athlete-next-game.module.state";
import {AnalyticsService} from "../../../../../third-party-services/analytics/analytics-service";
import {MarketNavigationClickEvent} from "../../../../../core/models/events/market-navigation-click-event";
import {APP} from "../../../../../core/app/consts";

export class AthleteNextGameModuleMarketNavigationClickEventHandler extends AnalyticsEventHandler {
  type = ATHLETE_WIDGET.ACTION_TYPES.marketNavigationClick;
  controller: AthleteNextGameModuleController;
  state: AthleteNextGameModuleState;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = MarketNavigationClickEvent;
  }

  async action(params) {
    const nextMarketType: String = this.state.playersBetsPredictions[params.index].type;
    const clickDirection: String = this.state.currentIndex < params.index ? APP.ANALYTICS.DIRECTIONS.RIGHT : APP.ANALYTICS.DIRECTIONS.LEFT

    const sendParams = {nextMarketType, clickDirection, ...params}

    const clickEvent: MarketNavigationClickEvent = new this.eventType(sendParams);
    await this.analyticsService.createEvent(clickEvent);

    this.state.currentIndex = params.index;
  }
}
